import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/home/HeroSection';
import InlineContactForm from '../components/home/InlineContactForm';
import TrustBar from '../components/home/TrustBar';
import ServicesEditorial from '../components/home/ServicesEditorial';
import JustinQuote from '../components/home/JustinQuote';
import HowItWorks from '../components/home/HowItWorks';
import AlternatingSection from '../components/home/AlternatingSection';
import TeamSection from '../components/home/TeamSection';
import ClientMomentSection from '../components/home/ClientMomentSection';
import FeaturedProjects from '../components/home/FeaturedProjects';
import VideoSection from '../components/home/VideoSection';
import ReviewsSection from '../components/home/ReviewsSection';
import StatsBar from '../components/home/StatsBar';
import CTASection from '../components/shared/CTASection';

export default function Home() {
  return (
    <div>
      <Helmet>
        <title>Terza Costa Construction | Remodeling &amp; EV Charger Installation — Rockport, TX</title>
        <meta name="description" content="Terza Costa Construction — Rockport, TX remodeling contractor serving the Coastal Bend. Kitchen remodels, bathroom renovations, home additions, Level 2 EV charger installation, electrical panel upgrades, plumbing. Licensed &amp; insured. Call Justin: (281) 203-7688." />
        <link rel="canonical" href="https://tercosta.com/" />
        <meta property="og:title" content="Terza Costa Construction | Remodeling &amp; EV Charger Installation — Rockport, TX" />
        <meta property="og:description" content="Residential remodeling and EV charger installation serving Rockport, Corpus Christi, and the entire Coastal Bend. Level 2 home EV chargers, kitchen &amp; bathroom remodels, electrical upgrades. Licensed &amp; insured." />
        <meta property="og:url" content="https://tercosta.com/" />
        <meta name="twitter:title" content="Terza Costa Construction | Remodeling &amp; EV Charger Installation — Rockport, TX" />
        <meta name="twitter:description" content="Residential remodeling and EV charger installation serving Rockport, Corpus Christi, and the entire Coastal Bend. Licensed &amp; insured." />
      </Helmet>
      <HeroSection />

      <TrustBar />

      <ServicesEditorial />

      <JustinQuote />

      <ReviewsSection />

      <HowItWorks />

      <AlternatingSection
        eyebrow="Our Standard"
        title="Preparation Is Part of the Craft"
        text="Remodeling can be messy — but it doesn't have to disrupt your entire home. At Terza Costa, we protect your space from day one: floor-to-ceiling coverings, organized staging areas, clean jobsites every single day. We believe quality work starts long before the first nail is driven."
        image="/images/ab956198a_647263888_122112497919221049_2421224019533847055_n.jpg"
        imageAlt="Terza Costa Construction job site preparation and floor protection Rockport TX"
        imageRight
      />

      <AlternatingSection
        eyebrow="Clear Communication"
        title="No Surprises. No Runaround."
        text="We walk through every phase of your project together — timeline, materials, budget, and expectations. You'll always know where things stand. Honest pricing from the first estimate. Clear updates throughout the build. And a crew that respects your home and your time."
        image="/images/40f754988_656018932_122114816673221049_6743965943269587652_n.jpg"
        imageAlt="Terza Costa Construction bathroom installation Rockport TX"
        imageRight={false}
      />

      <TeamSection />

      <ClientMomentSection />

      <FeaturedProjects />

      <VideoSection />

      <StatsBar />

      <InlineContactForm />

      <CTASection />

    </div>
  );
}